import axios from 'axios'
import router from "../router";
import { MessageBox } from 'element-ui';
import Cookies from 'js-cookie'

// 事件触发器
export default {
  show ({commit}) {
    commit('SHOW')
  },
  hidden ({commit}) {
    commit('HIDDEN')
  },
  size ({commit}, s) {
    commit('SIZE', s)
  },
  scroll ({commit}, h) {
    commit('SCROLL', h)
  },
  goods ({commit}, f) {
    commit('GOODS', f)
  },
  addCart ({commit}, r) {
    commit('ADDCART', r)
  },
  isNum ({commit}, bool) {
    commit('ISNUM', bool)
  },
  modifyconfig ({commit}, num) {
    commit('MODIFYCONFIG', num)
  },
  modifypage ({commit}, num) {
    commit('MODIFYPAGE', num)
  },
  modifynum ({commit}, num) {
    commit('MODIFYNUM', num)
  },
  modifyLeadStep({commit}, obj){
    // console.log('store@', obj)
    commit('MODIFYLEADSTEP', obj);
  },
  setTagDialog({commit}, obj){
    //新建快捷菜单
    commit('ADDTAGDIALOG', obj);
  },
  // 信息补全
  // 如果是采购商 不做校验 直接执行
  // type: 1 跳转首页
  informationCompletion ({commit, state}, cb, type) {
    commit('setUserStatus');
    console.log(router, 'routerrouterrouter')
    let userStatus = state.userStatus
    let userInfo = state.userInfo
    if (userStatus.isLogin == '') {
      //  未登录
      router.push({path: '/login'});
      return false
    }
    if (userInfo.userTag == '20') {
      cb && cb()
      return false
    }
    if (userStatus.examineStatus == '200') {
      router.push({
        path: "registerExamine",
        query: {
          email: userInfo.email ,
          companyId: userInfo.companyId ,
          companyName: userInfo.companyName,
          orgIdentity: userInfo.orgIdentity,
          regAddrType: userInfo.regAddrType,
          trueName: userInfo.trueName
        }
      })
    } else if (userStatus.examineStatus == '300') {
      router.push({
        path:"registerFailed",
        query:{
          userId: userInfo.id,
          email: userInfo.email,
          companyId: userInfo.companyId,
          companyName: userInfo.companyName,
          orgIdentity: userInfo.orgIdentity,
          regAddrType: userInfo.regAddrType,
          regeisterType: userStatus.regeisterType,
          exmaineMessage: userStatus.exmaineMessage,
          createUserId: userInfo.createUserId
        }
      })
    } else if (userStatus.companyCompleteStatus == "1") {
      MessageBox.alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
        dangerouslyUseHTMLString: true,
        customClass:'mobileText',
        center: true,
        showClose:false,
        callback: action => {
          if (location.pathname != '/') {
            router.push({path:'/'});
          }
        }
      });
    } else if (userStatus.checkFlag == 200 && userStatus.talkLater >=14) {
      MessageBox.confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
        cancelButtonClass:'cancelBtn',
        customClass:'mobileText',
        cancelButtonText: '以后再说',
        confirmButtonText: '点我补全',
        center: true
      }).then(() => {
        router.push({path:'/inforPerfection'});
      }).catch(() => {
        axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
        }).then((res) => {
          let data = res.data;
          router.push({path:'/'});
          Cookies.remove('TALK_LATER_' + data.userId);
          Cookies.remove('TALK_LATER_' + data.userId, data.instanceDay);
        });
      });
    } else {
      cb && cb()
    }
  },

  // findWebDto 存储用户状态
  async findWebDtoHandler({commit, state}) {
    commit('setUserStatus');

    let userStatus = state.userStatus
    let res = await axios.post('/onelink.mdata.main.api/web/findWebDto')
    let data = res.data;
    let checkFlagStatus = data.checkFlag ? '100': '200'
    Cookies.set("COMPANY_COMPLETE_STATUS_"+userStatus.justId, data.companyCompleteStatus + '' ,{domain:'.onelinkplus.com',expires:10 });
    Cookies.remove('checkFlag');
    Cookies.set('checkFlag',checkFlagStatus,{domain:'.onelinkplus.com',expires:10});
    localStorage.setItem('checkFlag', checkFlagStatus);
  }
}





// // findWebDto 存储用户状态
// async findWebDtoHandler({commit, state}) {
//   commit('setUserStatus');
//
//   let userStatus = state.userStatus
//   axios.post('/onelink.mdata.main.api/web/findWebDto', {
//   }).then((res) => {
//     let data = res.data;
//     let checkFlagStatus = data.checkFlag ? '100': '200'
//     Cookies.set("COMPANY_COMPLETE_STATUS_"+userStatus.justId, data.companyCompleteStatus + '' ,{domain:'.onelinkplus.com',expires:10 });
//     Cookies.remove('checkFlag');
//     Cookies.set('checkFlag',checkFlagStatus,{domain:'.onelinkplus.com',expires:10});
//     localStorage.setItem('checkFlag', checkFlagStatus);
//   });
// }



// WEBPACK FOOTER //
// ./src/store/actions.js